import authInstance from "../Interceptor/interceptor";

export const addAdmissionEffect = (formData) => {
  return authInstance.post("/admissions/insertadmission", formData);
};

export const deleteAdmissionEffect = (id) => {
  return authInstance.delete(`/admissions/deleteadmission/${id}`);
};

export const editAdmissionEffect = (id, formData) => {
  return authInstance.put(
    `/admissions/dischargeadmission/${formData.admissionId}`,
    formData.admissionData
  );
};

export const ViewAdmissionEffect = (id) => {
  return authInstance.get(
    `/admissions/getadmissionbypatient?patient_id=${id}&admission_status=1`
  );
};
export const listAdmissionEffect = (payload) => {
  const { pageNo, pagesize, pagination_required, search, search_by } = payload;

  return authInstance.get(
    `/admissions/list?pageNo=${pageNo}&pagesize=${pagesize}&pagination_required=${pagination_required}&search_by=${search_by}&search=${search}`
  );
};

export const ViewAdmissionPatientEffect = (id) => {
  return authInstance.get(`/admissions/getAdmission?admission_id=${id}`);
};
export const listReportEffect = (payload) => {
  const { pageNo, pagesize, pagination_required, search, search_by } = payload;
  return authInstance.get(
    `/admissions/reportlist?pageNo=${pageNo}&pagesize=${pagesize}&pagination_required=${pagination_required}&search=${search}&search_by=${search_by}`
  );
};

export const listAdmission = (pageNo) => {
  return authInstance.get(
    `/admissions/admissionlist?pageNo=${pageNo}&pagesize=10&pagination_required=true`
  );
};

export const listAdmissionAll = (pageNo) => {
  return authInstance.get(
    `/admissions/list?pageNo=${pageNo}&pagesize=10&pagination_required=false`
  );
};
